import React, { useEffect, useState } from 'react';
import { RestPOSTJSON } from '../utils/ApiREST';
import { ModalVideos } from '../components/Modal/ModalVideos';

function Listar() {
  const [listaVids, setListaVids] = useState([]);
  const [video, setVideo] = useState('');

  const requestActualiz = async () => {
    let let_get = { listar: true, borrar: false };
    const resultados = await RestPOSTJSON(let_get, null);
    
    if (Array.isArray(resultados)) {
      // Garantiza que no existan nombres de archivos duplicados en la lista
      setListaVids([...new Set(resultados)]);
    } else {
      setListaVids([]);
    }
  };

  const requestDelete = async () => {
    let let_get = { listar: false, borrar: true };
    const resultados = await RestPOSTJSON(let_get, null);
    
    if (Array.isArray(resultados)) {
      setListaVids([...new Set(resultados)]);
    } else {
      setListaVids([]);
    }
  };

  useEffect(() => {
    requestActualiz();
  }, []);

  const verVideo = (dato) => {
    setVideo(dato);
  };

  return (
    <>
      <section className='caja3-block section-titulo bg-secondary text-white'>
        Videos disponibles
      </section>

      <section className='caja2-block section-opc'>
        <button 
          className='btn btn-ico btn-primary btn-lg w-0 radius50'
          onClick={requestActualiz}
        >
          <span className='refreshsvg svg-color-claro'></span>
        </button>

        <button 
          className='btn btn-ico btn-danger btn-lg w-0 radius50'
          onClick={requestDelete}
        >
          <span className='deletesvg svg-color-claro'></span>
        </button>
      </section>

      {Array.isArray(listaVids) && listaVids.length > 0 && (
        <section className='caja3-block'>
          {listaVids.map((dato, indice) => (
            <section key={indice} className='caja1-block section-video'>
              <button 
                className='btn btn-ico btn-danger btn-lg w-0 radius50'
                onClick={() => verVideo(dato)}
              >
                <span className='play_arrowsvg svg-color-claro'></span>
              </button>
              <span>{dato}</span>
            </section>
          ))}
        </section>
      )}

      {video && (
        <ModalVideos 
          titulo={`Video de mi casita: ${video}`} 
          video={video} 
          setVideo={setVideo} 
        />
      )}
    </>
  );
}

export { Listar };